import { isReloginOpen } from 'ts-utils/session'

export const SHOW = 'errorPage/SHOW'
export const HIDE = 'errorPage/HIDE'

const initState = {
    show: false,
    f: '',
    logoHref: '',
    buttonHref: ''
}


export default (state = initState, action) => {
    switch(action.type) {
        case SHOW:
            // 로그인이 풀려 실패한 요청이면 에러 화면 대신 재로그인 모달만 (로그인 후 화면은 그대로)
            if (isReloginOpen()) return state

            return {
                show: true,
                f: action.f,
                logoHref: action.logoHref,
                buttonHref: action.buttonHref
            }
        case HIDE:
            return initState
        default:
            return state
    }
}